import { render, staticRenderFns } from "./pointFestivalWinners.vue?vue&type=template&id=dd3f86f2&scoped=true"
import script from "./pointFestivalWinners.vue?vue&type=script&lang=js"
export * from "./pointFestivalWinners.vue?vue&type=script&lang=js"
import style0 from "./pointFestivalWinners.vue?vue&type=style&index=0&id=dd3f86f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd3f86f2",
  null
  
)

export default component.exports